import {
  animate,
  keyframes,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const groupViewAnimations = [
  trigger('menuExpansion', [
    transition(
      ':enter',
      animate(
        '300ms cubic-bezier(0.4, 0.0, 0.2, 1)',
        keyframes([
          style({
            height: '0px',
            minHeight: '0px',
            overflow: 'hidden',
            opacity: 0,
          }),
          style({
            height: '*',
            minHeight: '*',
            overflow: 'inherit',
            opacity: 1,
          }),
        ]),
      ),
    ),
    transition(
      ':leave',
      animate(
        '300ms cubic-bezier(0.4, 0.0, 0.2, 1)',
        keyframes([
          style({
            height: '*',
            minHeight: '*',
            overflow: 'inherit',
            opacity: 1,
          }),
          style({
            height: '0',
            minHeight: '0',
            overflow: 'hidden',
            opacity: 0,
          }),
        ]),
      ),
    ),
  ]),
  trigger('fadeIn', [
    transition(
      ':enter',
      animate(
        '1000ms cubic-bezier(0.4, 0.0, 0.2, 1)',
        keyframes([
          style({
            opacity: 0,
          }),
          style({
            opacity: 1,
          }),
        ]),
      ),
    ),
  ]),
];
